module.exports = __webpack_public_path__ + "static/media/unknown_user.5912899b.svg";